export default __webpack_public_path__ + "static/portfolio-17-02d28414d0a8d3761698a32c6ee0ce79.jpg";